/**
 * 司法确认申请
 */
const JudicialConfirm = () => import('@/module/index/layout/JudicialConfirm.vue')
const judicialConfirm = () => import('@/module/index/pages/judicial/judicialConfirm.vue')
const judicialDetail = () => import('@/module/index/pages/judicial/judicialDetail.vue')
const adjust = () => import('@/module/index/pages/judicial/adjust.vue')
const applyRecord = () => import('@/module/index/pages/judicial/applyRecord.vue')

export default {
  path: '/judicial',
  component: JudicialConfirm,
  meta: {
    title: '司法确认-海南涉外民商事法庭案件多元化解平台',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: false
  },
  children: [{
    name: 'judicialConfirm',
    path: '/judicial/confirm/:id', // 申请司法确认
    component: judicialConfirm
  },
  {
    name: 'adjust',
    path: '/judicial/adjust/:id', // 申请调解申请书
    component: adjust
  },
  {
    name: 'applyRecord',
    path: '/judicial/record/:id',
    component: applyRecord
  },
  {
    path: '/judicial/detail/:id', // 司法确认详情
    component: judicialDetail
  }
  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/judicial.js